import { Fragment } from 'react';
import useRequest from 'use-request';
import moment from 'moment';

import { Avatar, Box, Grid, Typography } from '@mui/material';

import { formatPhone } from '../../utils/formatter';

import publicServices from '../../services/publicServices';

const ProposalViewContacts = ({ id, property, issueDate, installationSchedule, createdBy }) => {
  const { value: companyData } = useRequest(() => publicServices.getPublicSettings().then((response) => ({
    office: response.data.value.officePhone,
    fax: response.data.value.fax,
    cell: response.data.value.cellPhone,
    email: response.data.value.email,
    contactName: response.data.value.contactName,
    companyName: response.data.value.companyName,
    address: response.data.value.address,
  })), []);

  return (
    <Box sx={{ mt: 5 }}>
      <Grid container spacing={2}>
        <Grid item sm={8} xs={12}>
          <Grid container spacing={2} justifyContent="flex-start">
            <Grid item xs={1}>
              <Typography sx={{ fontSize: 12 }}>From</Typography>
            </Grid>

            <Grid item xs={10}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Box>
                  <Avatar
                    src={createdBy.photo?.url}
                    variant="square"
                    alt={createdBy.fullName}
                    sx={{ width: '100px', height: 'auto', alignItems: 'flex-start' }}
                  />
                </Box>

                <Box>
                  <Typography>
                    <strong>{createdBy.fullName}</strong>

                    {companyData?.companyName && <Typography sx={{ fontSize: 12 }}>{companyData.companyName}</Typography>}
                    {companyData?.address && <Typography sx={{ fontSize: 12 }}>{companyData.address}</Typography>}
                    {companyData?.office && <Typography sx={{ fontSize: 12 }}>{formatPhone(companyData.office)}</Typography>}
                    {companyData?.cell && <Typography sx={{ fontSize: 12 }}>{formatPhone(companyData.cell)}</Typography>}
                    {companyData?.email && <Typography sx={{ fontSize: 12 }}>{companyData.email}</Typography>}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="flex-start" sx={{ marginTop: 2 }}>
            <Grid item xs={1}>
              <Typography sx={{ fontSize: 12 }}>To</Typography>
            </Grid>

            <Grid item xs={10}>
              {property.clients?.map((client, index) => (
                <Box sx={{ display: 'flex', gap: 2, marginTop: index === 0 ? 0 : 2 }} key={client.id}>
                  <Box>
                    <Avatar
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABlCAYAAABUfC3PAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMWSURBVHgB7dxdThNRGMbxd3qmNK1p0xpQlI9UQyPGG7sTt+KKXIK4A3aAC1BpkKJGYptWbAoz1Dk13uAcrdEz53knzy8hhI8L4M/Tz5NGkpnNZt2rq/SFyOKpSNQWCiA6qFYrz+v1+iD6ESQ5YgwI42rV9KPJZPoyC/JMCMVhFuXrQgjJuCKEps0ogBgFEKMAYhRAjAKIUQAxCiBGAcQogBgFEKMAYhRAjAKIUQAxCiBGAcQogBgFUCmiJEmyfCuLWBSzId4OjuXLaLT8eGN9XXbub0mtVhPN1J5msSFskJsLsUG2szB3skBaqYtycx0umlejKoprHS5aV6MiyqrrcNG2Gvgof7sOF02rgY3yr+tw0bAayCj/ax0u6KuBiuJrHS6oq4GJ4nsdLoirCR6l6HW4IK0maJRQ63BBWU2QKCjrcAm9msKjoK3DJeRqCouCvg6XEKspJIqWdbgUvRqvUbSuw6Wo1XiLon0dLkWsxkuU92dDOR0Opcy6O7tyb3NTfPDyHP3n83Mpu9Mzf/90XqKkJbvIypOkqfjiJUqj0ZCy2/B4neIlyt6Dh15/6NBazebyVpgv3u+nzOfzXz43mU7lzfE7QfZorye3chZvjJE49nsyy/u5r7zb9GuXl4LO/uFDPfbFY6uAGAUQowBSe5Y4NrGY2OR+LU3S7H6E3vtKKqN0d7OHOO7+/iGOD58+yuDkRDRSd/FlY/wpyM/v297yd1/CJ3VRbnc6K39vq9kSjXhFD4hRADEKIEYBxCiAGAUQowBiFECMAohRADEKIEYBxCiAGAWQuie57BNXxqz2v+TzFKNP6qJcfLuQsuPFFyBGARQkij0OGhsjqGprNWk06hJKkCg2yJP9x8tfHo39mfZ7veURplCCv+JE3gHwkBBecSL4rS/tL8LpA6/oATEKIEYBxCiAGAUQowBiFECMAohRADEKIEYBxCiAGAUQowBiFECMAohRADEKIEYBZKOMhaDYKK+FYCwWi1fRaDTrGpMeZR+3hYLKgoyvr+N+pdOpD9LU9EWiA6EgbIzs3aENYnt8B1oSZdU2Gf7kAAAAAElFTkSuQmCC"
                      variant="square"
                      alt={createdBy.fullName}
                      sx={{ width: '100px', height: '100px' }}
                    />
                  </Box>

                  <Box>
                    <Typography>
                      <strong>{client.client.fullName}</strong>

                      {index === 0 && <Typography sx={{ fontSize: 12 }}>{property.address}</Typography>}
                      <Typography sx={{ fontSize: 12 }}>{formatPhone(client.client.phoneNumber)}</Typography>
                      <Typography sx={{ fontSize: 12 }}>{client.client.email}</Typography>
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Grid>
          </Grid>
        </Grid>

        <Grid item sm={4} xs={8}>
          <Grid container spacing={2} justifyContent={{ md: 'flex-end' }}>
            <Grid item md={5} xs={6}>
              <Typography sx={{ fontSize: 12 }}>
                <strong>Proposal ID:</strong>
              </Typography>
            </Grid>

            <Grid item md={5} xs={6}>
              <Typography sx={{ fontSize: 12 }}>
                <strong>{id}</strong>
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent={{ md: 'flex-end' }}>
            <Grid item md={5} xs={6}>
              <Typography sx={{ fontSize: 12 }}>
                <strong>Issue Date:</strong>
              </Typography>
            </Grid>

            <Grid item md={5} xs={6}>
              <Typography sx={{ fontSize: 12 }}>{moment(issueDate).format('MM/DD/YYYY')}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent={{ md: 'flex-end' }}>
            <Grid item md={5} xs={6}>
              <Typography sx={{ fontSize: 12 }}>
                <strong>Install Date:</strong>
              </Typography>
            </Grid>

            <Grid item md={5} xs={6}>
              <Typography sx={{ fontSize: 12 }}>
                {installationSchedule.map((el) => (
                  <Fragment key={el.id}>
                    <span>
                      {moment(el.date).utc().format('MM/DD/YYYY')} {el.installationTime}
                    </span>
                    <br />
                  </Fragment>
                ))}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid item xs={6} md={4}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Typography variant="body2" sx={{ minWidth: 34, fontSize: 12 }}>
              From
            </Typography>

            <Box sx={{ borderLeft: '1px solid #000', paddingLeft: 1 }}>
              <Typography sx={{ fontSize: 12 }}>
                <strong>{companyData?.contactName}</strong>
              </Typography>
              <Typography sx={{ fontSize: 12 }}>{companyData?.companyName}</Typography>
              <Typography sx={{ fontSize: 12 }}>{companyData?.address}</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={6} md={4}>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Box>
              <Typography sx={{ fontSize: 12 }}>Office:</Typography>
              <Typography sx={{ fontSize: 12 }}>Fax:</Typography>
              <Typography sx={{ fontSize: 12 }}>Cell:</Typography>
              <Typography sx={{ fontSize: 12 }}>Email:</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: 12 }}>{formatPhone(companyData?.office)}</Typography>
              <Typography sx={{ fontSize: 12 }}>{formatPhone(companyData?.fax)}</Typography>
              <Typography sx={{ fontSize: 12 }}>{formatPhone(companyData?.cell)}</Typography>
              <Typography sx={{ fontSize: 12 }}>{companyData?.email}</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={6} md={4}>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Typography sx={{ maxWidth: '35%', width: '100%', fontSize: 12 }}>
              <strong>Proposal ID:</strong>
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>{id}</strong>
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 3 }}>
            <Typography sx={{ maxWidth: '35%', width: '100%', fontSize: 12 }}>
              <strong>Issue Date:</strong>
            </Typography>
            <Typography sx={{ fontSize: 12 }}>{moment(issueDate).format('MM/DD/YYYY')}</Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 3 }}>
            <Typography sx={{ maxWidth: '35%', width: '100%', fontSize: 12 }}>
              <strong>Billing Address:</strong>
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              {property.address === billingPlace?.label ? 'Same' : billingPlace?.label}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 3 }}>
            <Typography sx={{ maxWidth: '35%', width: '100%', fontSize: 12 }}>
              <strong>Install Date:</strong>
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              {installationSchedule.map((el) => (
                <Fragment key={el.id}>
                  <span>
                    {moment(el.date).utc().format('MM/DD/YYYY')} {el.installationTime}
                  </span>
                  <br />
                </Fragment>
              ))}
            </Typography>
          </Box>
        </Grid> */}

        {/* {property.clients.slice(0, 2).map((client, index) => (
          <Grid item xs={6} md={4} key={client.id}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {index === 0 && <Typography sx={{ minWidth: 34, fontSize: 12 }}>To</Typography>}

              <Box
                sx={{
                  borderLeft: index === 0 && '1px solid #000',
                  paddingLeft: index === 0 && 1,
                  paddingRight: index === 0 && { md: 1, xs: 0 },
                }}
              >
                <Typography sx={{ fontSize: 12 }}>
                  <strong>{client.client.fullName}</strong>
                </Typography>
                {client.relation && <Typography sx={{ fontSize: 12 }}>{client.relation}</Typography>}
                <Typography sx={{ fontSize: 12 }}>{property.address}</Typography>
                <Typography sx={{ fontSize: 12 }}>{formatPhone(client.client.phoneNumber)}</Typography>
                <Typography sx={{ fontSize: 12 }}>{client.client.email}</Typography>
              </Box>
            </Box>
          </Grid>
        ))} */}

        {/* OLD VERSION BELOW */}

        {/* {companyData && (
          <Grid item xs={6} md={4}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Typography variant="body2" sx={{ minWidth: 34, fontSize: 12 }}>
                From
              </Typography>

              <Box sx={{ borderLeft: '1px solid #000', paddingLeft: 1 }}>
                <Typography variant="body2">
                  <strong>{companyData?.contactName}</strong>
                </Typography>
                <Typography sx={{ fontSize: 12 }}>{companyData?.companyName}</Typography>
                <Typography sx={{ fontSize: 12 }}>{companyData?.address}</Typography>
              </Box>
            </Box>
          </Grid>
        )} */}

        {/* {companyData && (
          <Grid item xs={6} md={4}>
            <Box sx={{ display: 'flex', gap: 3 }}>
              <Box>
                <Typography sx={font_size}>Office:</Typography>
                <Typography sx={font_size}>Fax:</Typography>
                <Typography sx={font_size}>Cell:</Typography>
                <Typography sx={font_size}>Email:</Typography>
              </Box>
              <Box>
                <Typography sx={font_size}>{formatPhone(companyData?.office)}</Typography>
                <Typography sx={font_size}>{formatPhone(companyData?.fax)}</Typography>
                <Typography sx={font_size}>{formatPhone(companyData?.cell)}</Typography>
                <Typography sx={font_size}>{companyData?.email}</Typography>
              </Box>
            </Box>
          </Grid>
        )} */}

        {/* <Grid item xs={12} md={4} sx={{ order: { xs: 3, md: 'unset' } }}>
          <Grid container>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: { md: 3, xs: 0 } }}>
                <Typography sx={{ fontSize: 12, width: { md: '30%', xs: '40%' } }}>
                  <strong>Proposal ID:</strong>
                </Typography>

                <Typography sx={proposal_id_ellipsis}>
                  <strong>{id}</strong>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: { md: 3, xs: 0 } }}>
                <Typography sx={{ fontSize: 12, width: { md: '30%', xs: '40%' } }}>Issue Date:</Typography>
                <Typography sx={{ fontSize: 12 }}>{moment(issueDate).format('MM/DD/YYYY')}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 3 }}>
                <Typography sx={{ whiteSpace: 'nowrap', fontSize: 12, width: { md: '30%', xs: '40%' } }}>
                  <strong>Billing Address</strong>
                </Typography>
                <Typography sx={{ fontSize: 12 }}>
                  {property.address === billingPlace?.label ? 'Same' : billingPlace?.label}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: { md: 3, xs: 0 } }}>
                <Typography sx={{ whiteSpace: 'nowrap', fontSize: 12, width: { md: '30%', xs: '40%' } }}>
                  <strong>Install Date</strong>
                </Typography>

                <Typography sx={{ fontSize: 12 }}>
                  {installationSchedule.map((el) => (
                    <Fragment key={el.id}>
                      <span>
                        {moment(el.date).utc().format('MM/DD/YYYY')} {el.installationTime}
                      </span>
                      <br />
                    </Fragment>
                  ))}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid> */}

        {/* <Grid item sx={{ order: { xs: 2, md: 'unset' } }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Typography sx={{ minWidth: 34, fontSize: 12 }}>To</Typography>

            <Grid container spacing={2}>
              {property.clients.slice(0, 2).map((client) => (
                <Grid item xs={4}>
                  <Box
                    sx={{ borderLeft: '1px solid #000', paddingLeft: 1, paddingRight: { md: 1, xs: 0 } }}
                    key={client.id}
                  >
                    <Typography variant="body2">
                      <strong>{client.client.fullName}</strong>
                    </Typography>
                    {client.relation && (
                      <Typography sx={{ fontSize: { xs: 12, md: 14 } }}>{client.relation}</Typography>
                    )}
                    <Typography sx={{ fontSize: { xs: 12, md: 14 } }}>{property.address}</Typography>
                    <Typography sx={{ fontSize: { xs: 12, md: 14 } }}>
                      {formatPhone(client.client.phoneNumber)}
                    </Typography>
                    <Typography sx={{ fontSize: { xs: 12, md: 14 } }}>{client.client.email}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default ProposalViewContacts;
